import { render, staticRenderFns } from "./TalentPoolList.vue?vue&type=template&id=8fc51fc6&"
import script from "./TalentPoolList.vue?vue&type=script&lang=js&"
export * from "./TalentPoolList.vue?vue&type=script&lang=js&"
import style0 from "./TalentPoolList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VListItem,VSkeletonLoader})
